module.exports = __webpack_public_path__ + "fonts/interactive.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/interactive.svg
// module id = 7
// module chunks = 0